import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tableContainerFlex: {
    minWidth: '610px',
    overflowX: 'auto',
    overflowY: 'auto',
    paddingRight: '10px ',
    marginTop: '25px',
    height: 'calc(100% - 25px)',
    '& .MuiTableCell-root': {
      padding: '10px 0 10px 20px',
    },
    '& .MuiTableCell-stickyHeader': {
      left: 'unset',
      color: '#2C2D3E',
    },
  },
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    color: '#2C2D3E',
    padding: '5px 15px',
  },
  item: {
    display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'space-between',
    height: '100%',
    padding: '10px 25px 0px 15px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
  },
  headerRow: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0px',
  },
  headerButton: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    width: 'auto',
  },
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  fieldLimits: {
    textAlign: 'right',
    color: '#2C2D3E',
  },
  error: {
    color: 'red',
  },
}));
